import gql from 'graphql-tag'

export const fetchCartQuery = gql(`
query ($cart_id: String!) {
  cart(cart_id: $cart_id) {
    runnertype
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    outlet_details {
      outlet_name
      __typename
    }
    payer_details {
      payername
      street
      city
      zipcode
      __typename
    }
    progress_bar_data {
      iPalletQuantity,
      iMinimumOrderWeight,
      iMaximumOrderWeight,
      iTotalCartWeight,
      iTotalCartPalletQty,
      iTotalQty,
      iRunnerType,
      iFullTruck,
      iFullTruckFlag,
      iFullTruckRemaining,
      msg,
      canProceed,
      min_weight_reached,
      iTruckQuantity,
      __typename
    }
    available_payment_methods {
      code
      title
      __typename
    }
    selected_payment_method {
      code
      title
      __typename
    }
    id
    email
    multi_deposit
    ship_to_id
    grand_total_basic_price
    grand_total_basic_price_tax
    grand_total_your_price
    grand_total_your_price_tax
    grand_total_multi_deposit

    sap_payment_details
    sap_payment_code
    sap_payment_method
    total_discount
    total_advanced_payment_discount
    total_deposit_non_drs
    total_deposit_drs
    total_with_vat
    total_settlement
    cart_prices {
      grand_total_volume
      grand_total_deposit
      grand_total_price
      grand_total_price_with_vat
      grand_total_price_with_vat_returnable
      __typename
      returnable_items{
        parent_sku
        sku
        total_units
        total_price
        unit_price
        name
      }
    }
    items {
      id
      uid
      prices {
        price_per_unit_wo_vat
        price_per_unit_wo_vat_discounted
        total_your_price_base_discount
        total_your_price_discounted
        discount_details {
          discount
          discount_percentage
          __typename
        }
        total_volume
        your_price
        your_price_tax
        total_your_price
        total_your_price_tax
        favourites
        __typename
      }
      product {
        id
        name
        runner_type
        sku
        image {
          url
          __typename
        }
        __typename
      }
      quantity
      quantity_total
      number_of_packages
      number_of_layer
      number_of_layer_total
      number_of_pallet
      number_of_trucks
      pack_format
      __typename
    }

    __typename
  }
}
`)
